import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=1c8760ac&scoped=true&"
import script from "./Permissions.vue?vue&type=script&lang=ts&"
export * from "./Permissions.vue?vue&type=script&lang=ts&"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=1c8760ac&scoped=true&lang=scss&"
import style1 from "./Permissions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8760ac",
  null
  
)

export default component.exports